import React from "react";
import { summaryClauses } from "../../Utils/summaryClauses";
import "../../css/SummaryClauses.css";

const SummaryClauses = ({ isTouristEvent, declarations, onChange }) => {
  const clauses = isTouristEvent
    ? summaryClauses.touristEvent
    : summaryClauses.nonTouristEvent;

  const handleCheckRequired = () => {
    clauses.forEach((clause) => {
      if (clause.required && !declarations[clause.id]) {
        onChange(clause.id, true);
      }
    });
  };

  return (
    <div className="summary-clauses-container">
      <h3>Oświadczenia i regulaminy</h3>

      <div className="button-wrapper">
      <button type="button" className="check-required-btn" onClick={handleCheckRequired}>
        Zaznacz wymagane
      </button>
    </div>

      {clauses.map((clause) => (
        <div key={clause.id} className="form-group">
          <label style={{ fontWeight: clause.required ? "bold" : "normal" }}>
            <input
              type="checkbox"
              required={clause.required}
              checked={declarations[clause.id] || false}
              onChange={(e) => onChange(clause.id, e.target.checked)}
            />
            {clause.text}
          </label>
        </div>
      ))}
    </div>
  );
};

export default SummaryClauses;
